export default "__VITE_ASSET__2pRy8mLl__"